import './styles/SortSelect.scss';

import { MenuItem, Select, SelectProps, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { SortOption } from 'types/AppTypes';

export const SortSelect = (props: SelectProps & { items: SortOption[] }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography>{t(translations.common.sortBy())}:</Typography>
      <Select {...props} className="select">
        {props.items.map(item => (
          <MenuItem key={item.label} value={JSON.stringify(item.value)}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
